import React from "react"

const TasksAndCalendar = ({ className = "", ...props }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      className={className}
      {...props}
    >
      <path
        d="M10.6668 2.66699V8.00033M21.3332 2.66699V8.00033M4 13.3326H28M12 21.3337L14.6667 24.0003L20 18.667M6.66667 5.33262H25.3333C26.8061 5.33262 28 6.52652 28 7.99928V26.666C28 28.1387 26.8061 29.3326 25.3333 29.3326H6.66667C5.19391 29.3326 4 28.1387 4 26.666V7.99928C4 6.52652 5.19391 5.33262 6.66667 5.33262Z"
        stroke="#463DFB"
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default TasksAndCalendar
